var map = {
	"./americano.mp4": 2390,
	"./boulevardier.mp4": 9231,
	"./campari-soda.mp4": 6842,
	"./negroni.mp4": 8817,
	"./original/americano.mp4": 6615,
	"./original/boulevardier.mp4": 1742,
	"./original/campari-soda.mp4": 9108,
	"./original/mi-to.mp4": 4874,
	"./original/negroni.mp4": 569,
	"./original/shakerato.mp4": 8544,
	"./original/spritz.mp4": 7207,
	"./poster/americano.png": 5162,
	"./poster/americano.webp": 1811,
	"./poster/boulevardier.png": 2421,
	"./poster/boulevardier.webp": 6035,
	"./poster/campari-soda.png": 3230,
	"./poster/campari-soda.webp": 7993,
	"./poster/mi-to.png": 1792,
	"./poster/negroni.png": 6297,
	"./poster/negroni.webp": 824,
	"./poster/shakerato.png": 2734,
	"./poster/shakerato.webp": 4365,
	"./poster/spritz.png": 1780,
	"./poster/spritz.webp": 8099,
	"./shakerato.mp4": 410,
	"./spritz.mp4": 6308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9159;